import { memo } from 'react';
import { alpha, SxProps, Theme } from '@mui/material';
import MuiPopover from '@mui/material/Popover';
import { useGetResponsive } from '@stack/helpers/lib/responsive';

import PopoverProps from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const PopoverView: React.FC<PopoverProps> = (props) => {
  const {
    children,
    backdropColor = `${alpha('#4c4e64', 0.5)}`,
    open,
    anchorEl,
    sx: containerSx,
    slotProps = {},
    onClose,
    ...restProps
  } = props;

  // =============== HOOKS
  const { sm, md } = useGetResponsive();

  // =============== SLOT PROPS
  const { paper, ...restSlotProps } = slotProps;

  // =============== VARIABLES
  const horizontal = sm ? 'center' : 'left';

  // =============== VIEWS
  return (
    <>
      <MuiPopover
        anchorEl={anchorEl}
        open={open}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal,
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal,
        }}
        onClose={onClose}
        slotProps={{
          paper: {
            ...paper,
            sx: {
              marginTop: { xs: '0', md: '5px' },
              borderRadius: { xs: 0, md: 0.4 },
              minWidth: { xs: '100%', md: 458 },
              width: sm ? '100%' : 'auto',
              maxWidth: '100%',
              border: '0px !important',
              ...(md
                ? {
                    left: '0 !important',
                  }
                : {}),
              ...(sm
                ? {
                    top: '45px !important',
                  }
                : {}),
              ...(paper as { sx: SxProps<Theme> })?.sx,
            },
          },
          ...restSlotProps,
        }}
        sx={{
          ...containerSx,
          maxWidth: '100%',
          '& .MuiBackdrop-root': {
            backgroundColor: backdropColor,
          },
        }}
        {...restProps}
      >
        {children}
      </MuiPopover>
    </>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export const Popover = memo(PopoverView);
export default Popover;
